/*
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-24 16:46:24
 * @LastEditTime: 2021-01-06 17:02:50
 */
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import permission from './modules/permission'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    permission
  },
  getters
})

export default store
